import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../lib/supabaseClient"; // singleton!

export default function AuthCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    const url = new URL(window.location.href);
    const code = url.searchParams.get("code");
    const err = url.searchParams.get("error");

    console.log("[callback search]", url.search);

    (async () => {
      try {
        if (err) {
          console.error("[CALLBACK] provider error:", err);
          navigate(`/coming-soon?error=${encodeURIComponent(err)}`, { replace: true });
          return;
        }
        if (!code) {
          console.warn("[CALLBACK] no code on callback");
          navigate("/coming-soon?error=no_code", { replace: true });
          return;
        }

        // ✅ Wait for Supabase to automatically detect and process the session
        // Since detectSessionInUrl: true, Supabase will handle the exchange automatically
        console.log("[CALLBACK] Waiting for Supabase to process session...");
        
        // Wait a bit for the automatic session detection to complete
        await new Promise(resolve => setTimeout(resolve, 1000));
        
        // Check if we have a session now
        const { data: { session }, error: sessionError } = await supabase.auth.getSession();
        
        if (sessionError) {
          console.error("[CALLBACK] Session error:", sessionError);
          navigate("/coming-soon?error=session_failed", { replace: true });
          return;
        }
        
        if (!session) {
          console.error("[CALLBACK] No session found after callback");
          navigate("/coming-soon?error=no_session", { replace: true });
          return;
        }

        console.log("[CALLBACK] Session found, user authenticated:", session.user.email);

        // Clean up the URL
        window.history.replaceState({}, "", "/auth/callback");

        // Continue to post-auth route with role information
        const role = sessionStorage.getItem('login_intent_role');
        if (role) {
          console.log('[CALLBACK] Redirecting to post-auth with role:', role);
          navigate(`/post-auth?role=${role}`, { replace: true });
        } else {
          console.log('[CALLBACK] No role found, redirecting to post-auth');
          navigate("/post-auth", { replace: true });
        }
      } catch (e) {
        console.error("[CALLBACK] callback error:", e);
        navigate("/coming-soon?error=callback_failed", { replace: true });
      }
    })();
  }, [navigate]);

  return null;
}
